import { Skeleton } from "@/components/atoms";
import { usePricingProfileContext, ZoneRatesAddPanel } from "@/components/organisms";
import { Restricted } from "@/components/pages/Restricted/Restricted";

export const ZoneRatesAdd = () => {
  const { isFetching, isRestricted } = usePricingProfileContext();

  if (isFetching) {
    return (
      <div className="flex flex-1 flex-col min-h-[calc(100vh-120px)] px-5 py-4">
        <Skeleton />
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col min-h-[calc(100vh-120px)] px-5 py-4">
      {isRestricted ? <Restricted /> : <ZoneRatesAddPanel />}
    </div>
  );
};